<script>
import { api } from "@/state/services";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  methods: {
    refazerClient() {
      this.loading = true;

      api
        .post('limpanome/clients/refazer', {
          id: this.id
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O refazer foi realizado com sucesso!");

            this.loading = false;
            this.show = false;

            this.$emit('refazer');
          } else {
            this.$toast.error(response.data.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao refazer cliente, tente novamente.");
            this.loading = false;
          }
        });
    },
  },
};
</script>

<template>
  <b-modal v-model="show" modal-class="modal-bottom" hide-footer hide-header>
    <div class="px-3">
      <h5>Você tem certeza que deseja refazer este cliente?</h5>
      <p class="mb-0 mt-2 font-size-13">Será utilizado 1 crédito do seu saldo de refazer e um novo cadastro deste cliente será criado.</p>
      <div class="mt-4 d-flex justify-content-between">
        <b-button class="btn-lg" variant="info" :disabled="loading" v-on:click="refazerClient()">
          Refazer
          <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
        <b-button class="text-dark text-decoration-none" variant="link" v-on:click="show = false">Fechar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
